import addEnsureEntity from './extensions/ensureEntity'

export default function(store, options) {
  const DistributionList = store.defineModel('distributionList', {
    replaceKeys: {
      organizationKey: 'organizationId',
      totalMembers: 'memberCount',
      avatar: 'avatarUrl',
      displayName: 'name',
    },

    defaultValues: {
      memberCount: 0,
    },

    afterAssignment(entity) {
      entity.displayName = entity.name
    },

    relations: {
      belongsTo: {
        organization: { type: 'organization', foreignKey: 'organizationId' }
      },
    }
  })

  addEnsureEntity(DistributionList, {
    finder: (...args) => options.host.distributionLists.find(...args),
    placeholderEntityDelayBeforeRefreshing() { return store.host.config.placeholderEntityDelayBeforeRefreshing },
    placeholderEntityAllowLoading() { return store.host.config.placeholderEntityAllowLoading },

    defaultPlaceholderAttrs: { name: 'Loading Distribution List...' },
    defaultNotFoundAttrs: { name: '<Distribution List Not Found>' },
  })

  return DistributionList
}
